import Icon from 'veui/components/Icon'

Icon.register({
  'sign-question': {
    paths: [
      {
        d: 'M384 480a32 32 0 01-32-32 68.47 68.47 0 0114.12-41.83 69.65 69.65 0 0136-24.77A64.21 64.21 0 00448 319.08c-.47-34.3-28.77-62.6-63.07-63.07A64 64 0 00320 320a32 32 0 01-64 0 128 128 0 01256-1.81 128.44 128.44 0 01-91.79 124.61A5.54 5.54 0 00416 448a32 32 0 01-32 32zm0 32a40 40 0 1040 40 40 40 0 00-40-40zm137 196.33A353.09 353.09 0 10384 736a351 351 0 00137-27.67zm66.63-528A288 288 0 11384 96a286.15 286.15 0 01203.65 84.35z'
      }
    ],
    width: '768',
    height: '768'
  }
})
